import { combineReducers } from 'redux';

import { ACTION_ADD_PAYOUT_FEES } from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_PAYOUT_FEES:
      return { ...state, ...action.payload.payoutFees };

    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
